import Vue from "vue";

import WApp from "@/components/WApp.vue";
import WChip from "@/components/WChip.vue";
import WChipList from "@/components/WChipList.vue";
import WBtnIcon from "@/components/WBtnIcon.vue";
import WBtnIconHelp from "@/components/WBtnIconHelp.vue";
import WBtn from "@/components/WBtn.vue";
import WBtnPrint from "@/components/WBtnPrint.vue";
import WBtnPrevious from "@/components/WBtnPrevious.vue";
import WBtnNext from "@/components/WBtnNext.vue";
import WBtnActivate from "@/components/WBtnActivate.vue";
import WBtnDeactivate from "@/components/WBtnDeactivate.vue";
import WBtnApply from "@/components/WBtnApply.vue";
import WBtnAdd from "@/components/WBtnAdd.vue";
import WBtnUpdate from "@/components/WBtnUpdate.vue";
import WBtnDelete from "@/components/WBtnDelete.vue";
import WBtnClose from "@/components/WBtnClose.vue";
import WBtnUnlock from "@/components/WBtnUnlock.vue";
import WBtnLaunch from "@/components/WBtnLaunch.vue";
import WBtnLock from "@/components/WBtnLock.vue";
import WBtnReload from "@/components/WBtnReload.vue";
import WBtnExport from "@/components/WBtnExport.vue";
import WBtnImport from "@/components/WBtnImport.vue";
import WBtnArchive from "@/components/WBtnArchive.vue";
import WBtnUnarchive from "@/components/WBtnUnarchive.vue";
import WEnumSelect from "@/components/WEnumSelect.vue";
import WServerAutocomplete from "@/components/WServerAutocomplete.vue";
import WCityAutocomplete from "@/components/WCityAutocomplete.vue";
import WStateAutocomplete from "@/components/WStateAutocomplete.vue";
import WControlProgramAutocomplete from "@/views/Notification/ControlProgram/Components/WControlProgramAutocomplete.vue";
import WIssueAutocomplete from "@/views/Notification/ControlProgram/Components/WIssueAutocomplete.vue";
import WPasswordTextField from "@/components/WPasswordTextField.vue";
import WTextField from "@/components/WTextField.vue";
import WSimpleTextArea from "@/components/WSimpleTextArea.vue";
import WFileInput from "@/components/WFileInput.vue";
import WAutocomplete from "@/components/WAutocomplete.vue";
import WTextArea from "@/components/WTextArea.vue";
import WTimePicker from "@/components/WTimePicker.vue";
import WDatePicker from "@/components/WDatePicker.vue";
import WMonthPicker from "@/components/WMonthPicker.vue";
import WColorPicker from "@/components/WColorPicker.vue";
import WVuetifyColorPicker from "@/components/WVuetifyColorPicker.vue";
import WDataSelectAutocomplete from "@/components/WDataSelectAutocomplete.vue";
import WDialogToolbar from "@/components/WDialogToolbar.vue";
import WOverlay from "@/components/WOverlay.vue";
import WCardForm from "@/components/WCardForm.vue";
import WCountryStateAutocomplete from "@/components/WCountryStateAutocomplete.vue";
import WFieldset from "@/components/WFieldset.vue";
import WDataTable from "@/components/WDataTable.vue";
import WServerDataTable from "@/components/WServerDataTable.vue";
import WToolbar from "@/components/WToolbar.vue";
import WLabel from "@/components/WLabel.vue";
import WEditDialog from "@/components/WEditDialog.vue";
import WInlineText from "@/components/WInlineText.vue";
import WTabs from "@/components/WTabs.vue";
import WTooltip from "@/components/WTooltip.vue";


Vue.component('w-app', WApp);
Vue.component('w-fieldset', WFieldset);
Vue.component('w-enum-select', WEnumSelect);
Vue.component('w-server-autocomplete', WServerAutocomplete);
Vue.component('w-city-autocomplete', WCityAutocomplete);
Vue.component('w-state-autocomplete', WStateAutocomplete);
Vue.component('w-control-program-autocomplete', WControlProgramAutocomplete);
Vue.component('w-issue-autocomplete', WIssueAutocomplete);
Vue.component('w-color-picker', WColorPicker);
Vue.component("w-vuetify-color-picker", WVuetifyColorPicker);
Vue.component('w-password-text-field', WPasswordTextField);
Vue.component('w-text-field', WTextField);
Vue.component('w-simple-text-area', WSimpleTextArea);
Vue.component('w-file-input', WFileInput);
Vue.component('w-autocomplete', WAutocomplete);
Vue.component('w-text-area', WTextArea);
Vue.component('w-time-picker', WTimePicker);
Vue.component('w-date-picker', WDatePicker);
Vue.component('w-month-picker', WMonthPicker);
Vue.component('w-card-form', WCardForm);
Vue.component('w-overlay', WOverlay);
Vue.component('w-dialog-toolbar', WDialogToolbar);
Vue.component('w-data-select-autocomplete', WDataSelectAutocomplete);
Vue.component('w-country-state-autocomplete', WCountryStateAutocomplete);
Vue.component('w-chip', WChip);
Vue.component('w-chip-list', WChipList);
Vue.component('w-btn-icon', WBtnIcon);
Vue.component('w-btn-icon-help', WBtnIconHelp);
Vue.component('w-btn', WBtn);
Vue.component('w-btn-print', WBtnPrint);
Vue.component('w-btn-previous', WBtnPrevious);
Vue.component('w-btn-next', WBtnNext);
Vue.component('w-btn-activate', WBtnActivate);
Vue.component('w-btn-deactivate', WBtnDeactivate);
Vue.component('w-btn-apply', WBtnApply);
Vue.component('w-btn-add', WBtnAdd);
Vue.component('w-btn-update', WBtnUpdate);
Vue.component('w-btn-delete', WBtnDelete);
Vue.component('w-btn-close', WBtnClose);
Vue.component('w-btn-unlock', WBtnUnlock);
Vue.component('w-btn-lock', WBtnLock);
Vue.component('w-btn-launch', WBtnLaunch);
Vue.component('w-btn-reload', WBtnReload);
Vue.component('w-btn-export', WBtnExport);
Vue.component('w-btn-import', WBtnImport);
Vue.component('w-btn-archive', WBtnArchive);
Vue.component('w-btn-unarchive', WBtnUnarchive);
Vue.component('w-data-table', WDataTable);
Vue.component('w-server-data-table', WServerDataTable);
Vue.component('w-toolbar', WToolbar);
Vue.component('w-label', WLabel);
Vue.component("w-edit-dialog", WEditDialog);
Vue.component('w-inline-text', WInlineText);
Vue.component('w-tabs', WTabs);
Vue.component('w-tooltip', WTooltip);